module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<a href="#" class="text-apply">' +
((__t = ( strings.applyFilters )) == null ? '' : __t) +
'</a>\n\n';
 if (data.state.showClearIcon) { ;
__p += '\n<a href="#" class="tokens-clear clear-bar tooltipped tooltipped-n" aria-label="' +
((__t = ( strings.clearFilters )) == null ? '' : __t) +
'"><i class="fas fa-times-circle"></i></a>\n';
 } ;
__p += '\n';
 if (data.state.showSaveIcon) { ;
__p += '\n<a href="#" class="save-filter tooltipped tooltipped-nw" aria-label="' +
((__t = ( strings.saveFiltersTooltip )) == null ? '' : __t) +
'">\n    ';
 if (data.state.savedFilter) { ;
__p += '\n    <i class="fas fa-star saved-filter-applied"></i>\n    ';
 } else { ;
__p += '\n    <i class="far fa-star"></i>\n    ';
 } ;
__p += '\n</a>\n';
 } ;
__p += '\n<a href="#" class="switch-mode tooltipped tooltipped-nw ' +
((__t = ( data.state.tempTokensPresent ? 'disabled' : '' )) == null ? '' : __t) +
'" aria-label="' +
((__t = ( data.state.mode === 'text' ? strings.toggleEditorGUI : strings.toggleEditorText )) == null ? '' : __t) +
'"><i class="far fa-code"></i></a>\n';
return __p
}